import Vue from 'vue';
import vueSignature from 'vue-signature';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import vuetify from '@/plugins/vuetify';
import router from '@/plugins/router';
import store from '@/plugins/store';
import App from '@/App';
import '@babel/polyfill';
import '@/plugins/recaptcha';
import '@/filters';

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
Vue.use(vueSignature);

if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test') {
  Sentry.init({
    Vue,
    dsn: 'https://4b1bf4325f1e4a02b4f3c1d993b483b9@o1017291.ingest.sentry.io/5983061',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'rmr.fi', 'helmi.raumalkv.com', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
